import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellLink from "ds/components/Table/Row/CellLink";
import { replaceSubdomain } from "utils/history";
import {
  SharedModuleDataWithSpace,
  SharedModuleDataWithAccount,
} from "views/Account/SharedModulesNew/types";

const SharedModulesTableNameCell = ({
  item: sharedModule,
  ...cellProps
}: TableSimpleCellProps<SharedModuleDataWithSpace | SharedModuleDataWithAccount>) => {
  let moduleOrigin: string;
  if ("subdomain" in sharedModule && sharedModule.subdomain) {
    moduleOrigin = replaceSubdomain(window.location.origin, sharedModule.subdomain);
  } else {
    moduleOrigin = "";
  }

  const moduleUrl = `${moduleOrigin}/module/${sharedModule.id}`;

  return (
    <TableSimpleCell {...cellProps} role="rowheader">
      <TableCellLink href={moduleUrl} target={moduleOrigin && "_blank"}>
        {sharedModule.name}
      </TableCellLink>
    </TableSimpleCell>
  );
};

export default SharedModulesTableNameCell;
